// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ScrollbarVertical_scrollbar_UnM2N","bobber":"ScrollbarVertical_bobber_3eGnZ"};